import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey =
  'cx_foundations-back_to_help_center_with_brand_order-click';

/**
 * Click back to help center button and capture brand&#x2F;retailer token and brand order token if exists
 */
export function trackCxFoundationsBackToHelpCenterWithBrandOrderClick(
  retailerOrBrandToken: string,
  brandOrderToken: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: { retailerOrBrandToken, brandOrderToken },
  });
}
